import { useEffect, useState } from 'react';

/**
 * Returns true only after `fetching` has been true for at least `delayMs`.
 * Prevents a brief spinner flash on fast loads.
 */
export function useDeferredLoading(fetching: boolean, delayMs = 300): boolean {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (fetching) {
      const timer = setTimeout(() => setShowLoader(true), delayMs);
      return () => clearTimeout(timer);
    } else {
      // Reset is the whole point of the hook — once shown, we have to clear it
      // when fetching ends. There is no derivation that captures this.
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowLoader(false);
    }
  }, [fetching, delayMs]);

  return showLoader;
}
